import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const NotificationBadge: FC<{
  count: number;
  isFilled: boolean;
  className?: string;
}> = ({count, isFilled, className}) => {
  return (
    count > 0 && (
      <div
        className={clsxm(
          "flex size-5 shrink-0 items-center justify-center rounded-full px-1 py-px text-xs leading-none font-bold text-white transition-all duration-150",
          isFilled ? "bg-danger-raspberry" : "border-danger-raspberry text-danger-raspberry border",
          {
            "text-2xs w-auto": count >= 10 && count < 100,
            "text-3xs w-auto": count >= 100,
          },
          className,
        )}>
        {count >= 100 ? `99+` : count}
      </div>
    )
  );
};

export default NotificationBadge;
